'use client';

import { useSearchParams } from 'next/navigation';
import map from 'lodash/map';
import InfiniteBase from './InfiniteBase';
import ProductCard from 'app/components/product/card/ProductCard';
import replace from 'lodash/replace';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { createQueryString } from '@/utils';
import toNumber from 'lodash/toNumber';

const Infinite = ({
  productClassName = '',
  destinationElementId = null,
  category = '',
  data,
  url,
  ...pagination
}) => {
  const categoryName = category?.name;
  const searchParams = useSearchParams();
  const orderBy = searchParams.get('orderBy');
  const perPage = searchParams.get('perPage');
  const pathname = usePathname();
  const [activePage, setActivePage] = useState(toNumber(searchParams.get('page')) ?? 1);

  useEffect(() => {
    setActivePage(searchParams.get('page'));
  }, [pathname, pagination.currentPage, searchParams]);

  const handleDecodeUrl = url => {
    let jsonEncodedString = replace(url, '/api/product?props=', '');
    let jsonString = decodeURIComponent(jsonEncodedString);
    return JSON.parse(jsonString);
  };

  const handleEncodeUrl = obj => {
    return `/api/product?props=${encodeURIComponent(JSON.stringify(obj))}`;
  };

  const getHref = actualPage => {
    let page = Number(actualPage);
    const newPage = page + 1;
    let url = pathname +
      '?' +
      createQueryString(
        'page',
        newPage,
        searchParams,
        newPage === 1 ? 'page' : null,
      );
    setActivePage(newPage);
    history.replaceState(null, '', url);
  };

  const getKey = index => {
    let fetchUrl;
    let urlObj = handleDecodeUrl(url);
    let finalUrl;
    let changedUrlObj = {
      ...urlObj,
      searchParams: {
        page: index ? index + 1 : 2,
        perPage: perPage || Number(process.env.NEXT_PUBLIC_PRODUCT_DEFAULT_PER_PAGE),
        orderBy: orderBy ? orderBy : '',
      },
    };
    finalUrl = handleEncodeUrl(changedUrlObj);
    fetchUrl = `${finalUrl}&index=${index ? index : 1}`;
    return fetchUrl;
  };

  return (
    <InfiniteBase
      {...pagination}
      handleGetKey={getKey}
      handleGetHref={getHref}
      className={'text-center mt-8'}
      destinationElementId={destinationElementId}
      searchData={data}
      categoryName={categoryName}
      activePage={activePage}
      render={data =>
        map(data?.products, (product, index) => (
          <div
            key={`product-infinite-${product?.id}-${index}`}
            className={`${productClassName}`}
          >
            <ProductCard product={product} />
          </div>
        ))
      }
    />
  );
};

export default Infinite;
